// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  background-color: white;
  padding-left: var(--d-spacing-double);
  padding-right: var(--d-spacing-double);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.body {
  width: 100%;
  padding-left: var(--d-spacing-double);
  padding-right: var(--d-spacing-double);
}

.state-name {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  line-height: 26px;
  margin-bottom: calc(var(--d-spacing-single) / 2);
}

.default-question {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  line-height: 24px;
  padding-bottom: var(--d-spacing-double);
}

ion-input.value {
  --background: white;
  --color: var(--ion-color-primary);
  width: 100%;
  border: none;
}

.unit {
  color: var(--ion-color-primary);
}

ion-item::part(native) {
  background: white;
}

ion-item {
  --highlight-color-focused: var(--ion-color-primary);
  --highlight-color-valid: var(--ion-color-primary);
  --highlight-color-invalid: var(--ion-color-danger);
  --border-color: #bdbdbd;
}

.last-entry {
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  margin-top: calc(var(--d-spacing-single) / 2);
}

.selection-center {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/state-value/components/numeric-state-value-input/dwin-numeric-state-value-input.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,sCAAA;EACA,yCAAA;AADJ;;AAIA;EACI,WAAA;EACA,qCAAA;EACA,sCAAA;AADJ;;AAIA;ECfI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDcA,iBAAA;EACA,gDAAA;AAEJ;;AACA;ECdI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDaA,iBAAA;EACA,uCAAA;AAKJ;;AAFA;EACI,mBAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;AAKJ;;AAFA;EACI,+BAAA;AAKJ;;AAFA;EACI,iBAAA;AAKJ;;AAFA;EACI,mDAAA;EACA,iDAAA;EACA,kDAAA;EACA,uBAAA;AAKJ;;AAFA;ECrBI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDoBA,6CAAA;AAQJ;;AALA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAQJ","sourcesContent":["@import 'src/mixins.scss';\n\n.header {\n    width: 100%;\n    background-color: white;\n    padding-left: var(--d-spacing-double);\n    padding-right: var(--d-spacing-double);\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.body {\n    width: 100%;\n    padding-left: var(--d-spacing-double);\n    padding-right: var(--d-spacing-double);\n}\n\n.state-name {\n    @include h1-style;\n    line-height: 26px;\n    margin-bottom: calc(var(--d-spacing-single) / 2);\n}\n\n.default-question {\n    @include p1-style;\n    line-height: 24px;\n    padding-bottom: var(--d-spacing-double);\n}\n\nion-input.value {\n    --background: white;\n    --color: var(--ion-color-primary);\n    width: 100%;\n    border: none;\n}\n\n.unit {\n    color: var(--ion-color-primary);\n}\n\nion-item::part(native) {\n    background: white;\n}\n\nion-item {\n    --highlight-color-focused: var(--ion-color-primary);\n    --highlight-color-valid: var(--ion-color-primary);\n    --highlight-color-invalid: var(--ion-color-danger);\n    --border-color: #bdbdbd;\n}\n\n.last-entry {\n    @include p2-style;\n    margin-top: calc(var(--d-spacing-single) / 2);\n}\n\n.selection-center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
